/** Backend serializer'iga mos: apps/approvals/serializers.py */
import type { DriverStatus } from "@/features/drivers/types";

export type ApprovalKind = "hire" | "expense" | "bonus" | "transfer";
export type ApprovalStatus = "pending" | "approved" | "rejected" | "cancelled";

export interface ApprovalUserRef {
  id: number;
  display_name: string;
  initials: string;
}

export interface ApprovalDriverInfo {
  id: number;
  full_name: string;
  phone: string;
  status: DriverStatus;
  owner: string | null;
  team: string | null;
  current_job: string | null;
  start_date: string | null;
}

export interface Approval {
  id: number;
  kind: ApprovalKind;
  status: ApprovalStatus;
  branch: number | null;
  branch_name: string | null;
  requested_by: ApprovalUserRef | null;
  driver: number | null;
  driver_info: ApprovalDriverInfo | null;
  object_model: string;
  object_id: number | null;
  payload: Record<string, unknown>;
  evidence: string;
  summary: string;
  /** Hire: carrier to'lovi (faqat "budget" ruxsati bilan keladi) -- tasdiqlashda summa kiritiladi */
  fee?: { amount: string | null; carrier_default: string | null; carrier: string; due_date: string | null } | null;
  decided_by: ApprovalUserRef | null;
  decided_at: string | null;
  decision_reason: string;
  decision_note: string;
  created_at: string;
  version: number;
}

export interface ApprovalCounts {
  hire: number;
  expense: number;
  bonus: number;
  transfer: number;
  total: number;
}

export const KIND_LABEL: Record<ApprovalKind, string> = {
  hire: "Hire",
  transfer: "Transfer",
  expense: "Expense",
  bonus: "Bonus",
};

export const KIND_PLURAL: Record<ApprovalKind, string> = {
  hire: "Hires",
  transfer: "Transfers",
  expense: "Expenses",
  bonus: "Bonuses",
};

/** Hire rad etilganda driver qaytadigan statuslar (orientation -- standart) */
export const RETURN_TO_OPTIONS: { value: DriverStatus; label: string }[] = [
  { value: "orientation", label: "Orientation" },
  { value: "background_check", label: "Background check" },
  { value: "submitted", label: "Submitted" },
  { value: "docs", label: "Docs" },
  { value: "qualified", label: "Qualified" },
];

export function payloadString(payload: Record<string, unknown>, key: string): string {
  const v = payload[key];
  return v === null || v === undefined ? "" : String(v);
}
